var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("StudipPagination", {
        style: {
          visibility: _vm.totalItems <= _vm.perPage ? "hidden" : "visible",
        },
        attrs: {
          currentOffset: _vm.offset,
          totalItems: _vm.totalItems,
          itemsPerPage: _vm.perPage,
        },
        on: {
          updateOffset: _vm.onUpdateOffset,
        },
      }),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c("StudipPagination", {
        style: {
          visibility: _vm.totalItems <= _vm.perPage ? "hidden" : "visible",
        },
        attrs: {
          currentOffset: _vm.offset,
          totalItems: _vm.totalItems,
          itemsPerPage: _vm.perPage,
        },
        on: {
          updateOffset: _vm.onUpdateOffset,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }